/** Shared registration entry copy for the homepage and identity picker. */
export const registrationEntries = [
  { kind: "creator", href: "/register?kind=creator", title: "形象入驻", description: "建立并管理你的数字形象" },
  { kind: "merchant", href: "/register?kind=merchant", title: "厂商选角", description: "为厂商内容寻找合适主角" },
  { kind: "agent", href: "/register?kind=agent", title: "MCN 入驻", description: "管理达人，开展形象授权" },
] as const;

/** Homepage also exposes the MCN branch of the existing agent registration flow. */
export const homepageRegistrationEntries = [
  registrationEntries[0],
  registrationEntries[1],
  { ...registrationEntries[2], kind: "mcn" },
] as const;
